import React from 'react';
import { Badge as BadgePill } from 'react-bootstrap';

type Props = {
    badgeType: any;      // バッジのスタイル --- primary or success or danger or dark
    badgeValue: string;     // バッジの値
}

export const Badge: React.FC<Props> = (props: Props) => {
    const { badgeType, badgeValue } = props;

    return (
        <BadgePill pill bg={badgeType}>
            {badgeValue}
        </BadgePill>
    )
}
